module.exports = __webpack_public_path__ + "img/resource-zy-active.e81d4994.png";